import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query";
import type { CommentMention } from "@certa/types";
import { getUsersWhoCanBeMentioned } from "../services/userMentions.services";
import type { UserMentionSearchParams } from "../types/userMentions.types";

/**
 * Hook to fetch users who can be mentioned in a specific thread
 * Only triggers API call when searchTerm has 3 or more characters
 */
export const useUsersWhoCanBeMentioned = (
  params: UserMentionSearchParams,
  options?: UseQueryOptions<CommentMention[], Error>
) => {
  const { threadId, searchTerm } = params;

  return useQuery({
    queryKey: ["users-who-can-be-mentioned", threadId, searchTerm],
    queryFn: () => getUsersWhoCanBeMentioned(params),
    enabled: !!threadId && !!searchTerm && searchTerm.length >= 3,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    ...options
  });
};
